import React from 'react';

const LargePlusIcon: React.FC = () => (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    >
    <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11 0C11.2431 0 11.4763 0.0965773 11.6482 0.268486C11.8201 0.440394 11.9167 0.673552 11.9167 0.916667V10.0833H21.0833C21.3265 10.0833 21.5596 10.1799 21.7315 10.3518C21.9034 10.5237 22 10.7569 22 11C22 11.2431 21.9034 11.4763 21.7315 11.6482C21.5596 11.8201 21.3265 11.9167 21.0833 11.9167H11.9167V21.0833C11.9167 21.3265 11.8201 21.5596 11.6482 21.7315C11.4763 21.9034 11.2431 22 11 22C10.7569 22 10.5237 21.9034 10.3518 21.7315C10.1799 21.5596 10.0833 21.3265 10.0833 21.0833V11.9167H0.916667C0.673552 11.9167 0.440394 11.8201 0.268486 11.6482C0.0965773 11.4763 0 11.2431 0 11C0 10.7569 0.0965773 10.5237 0.268486 10.3518C0.440394 10.1799 0.673552 10.0833 0.916667 10.0833H10.0833V0.916667C10.0833 0.673552 10.1799 0.440394 10.3518 0.268486C10.5237 0.0965773 10.7569 0 11 0Z"
        fill="#333333"
    />
    </svg> 
);

export default LargePlusIcon;

